import React from 'react'

import { Modal } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

function MultiplePartsAssemblyModal({ instructions, onClose: handleClose }) {
  return (
    <Modal
      header="Assembly Instructions"
      isOpen
      onClose={handleClose}
      width="medium"
      size="medium"
    >
      <pre className="assembly-instructions-modal">
        {instructions}
      </pre>
    </Modal>
  )
}

MultiplePartsAssemblyModal.propTypes = {
  instructions: string.isRequired,
  onClose: func.isRequired,
}

export default MultiplePartsAssemblyModal
